// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__JER68","cell":"ColumnAccessor_cell__391SN","firstCellAccent":"ColumnAccessor_firstCellAccent__1t8qW"};